/**
 * Bundle Pack Addon for FLOWI Theme
 * Version: 1.0.0
 * Standalone JavaScript - No conflicts with Dawn theme
 */

(function() {
    'use strict';

    class BundlePackAddon {
      constructor(container) {
        this.container = container;
        this.cards = container.querySelectorAll('.bundle-pack-card');
        this.quantityInputs = container.querySelectorAll('.bundle-pack-card__quantity-input');
        this.quantityMeter = container.querySelector('[data-quantity-meter-addon]');

        this.selectedVariants = new Map();

        // En Shopify, le bundle-pack peut être une section séparée du formulaire
        // On cherche le formulaire produit principal (pas dans un drawer)
        let formCandidate = container.closest('form[action*="/cart/add"]');

        if (!formCandidate) {
          formCandidate = container.parentElement?.querySelector('form[action*="/cart/add"]');
        }

        if (!formCandidate) {
          const allForms = document.querySelectorAll('form[action*="/cart/add"]');

          for (const form of allForms) {
            const isInDrawer = form.closest('cart-drawer') ||
                               form.closest('#CartDrawer') ||
                               form.classList.contains('upsell-drawer-form');

            if (!isInDrawer) {
              formCandidate = form;
              break;
            }
          }
        }

        // Rejeter les formulaires upsell du cart drawer
        if (formCandidate && (
            formCandidate.closest('cart-drawer') ||
            formCandidate.closest('#CartDrawer') ||
            formCandidate.classList.contains('upsell-drawer-form')
        )) {
          this.productForm = null;
        } else {
          this.productForm = formCandidate;
        }

        this.displayMode = 'products';

        // Configuration par défaut des paliers
        this.tiers = [
          { qty: 1, text: '1 bottle', price: '$29.99/ea' },
          { qty: 2, text: '2 bottles', price: '$28.99/ea' },
          { qty: 3, text: '3 bottles', price: '$27.99/ea' },
          { qty: 4, text: '4+ bottles', price: '$26.99/ea' }
        ];

        // Configuration des discounts par palier (sur le total)
        this.discounts = {
          '1': { type: 'none', value: 0 },
          '2': { type: 'none', value: 0 },
          '3': { type: 'none', value: 0 },
          '4': { type: 'none', value: 0 },
          '5': { type: 'none', value: 0 }
        };

        this.init();
      }

      init() {
        this.loadConfiguration();
        this.clearLocalStorage();
        this.bindEvents();
        this.initializeQuantityButtons();
        this.initializeAddButtons();
        this.initializeMainProduct();
        this.updateQuantityMeter();
        this.updateProductForm();
        this.interceptFetchRequests();
        this.initializeScrollIndicator();
        this.initGridLayout();

        // Écouter quand ButtonPriceManager est prêt
        document.addEventListener('buttonPriceManagerReady', () => {
          if (this.selectedVariants.size > 0) {
            this.updateButtonPrice();
          }
        });
      }

      saveToLocalStorage() {
        const storageKey = 'bundle_selections_' + window.location.pathname;
        const selections = {};

        this.selectedVariants.forEach((data, variantId) => {
          selections[variantId] = data;
        });

        try {
          localStorage.setItem(storageKey, JSON.stringify(selections));
        } catch (e) {
          console.error('Erreur sauvegarde localStorage:', e);
        }
      }

      clearLocalStorage() {
        const storageKey = 'bundle_selections_' + window.location.pathname;
        try {
          localStorage.removeItem(storageKey);
        } catch (e) {
          console.error('Erreur suppression localStorage:', e);
        }
      }

      restoreFromLocalStorage() {
        const storageKey = 'bundle_selections_' + window.location.pathname;

        try {
          const saved = localStorage.getItem(storageKey);
          if (!saved) {
            return;
          }

          const selections = JSON.parse(saved);

          // Restaurer dans la Map
          Object.entries(selections).forEach(([variantId, data]) => {
            this.selectedVariants.set(variantId, data);

            // Mettre à jour l'UI
            const input = document.querySelector(`input[data-variant-id="${variantId}"]`);
            if (input) {
              input.value = data.quantity;
              const card = input.closest('.bundle-pack-card');
              if (card && data.quantity > 0) {
                card.classList.add('bundle-pack-card--selected');
                const quantityDisplay = card.querySelector('.bundle-pack-card__quantity-display');
                if (quantityDisplay) {
                  quantityDisplay.textContent = data.quantity;
                  quantityDisplay.style.display = 'flex';
                }
              }
            }
          });

          // Mettre à jour le prix du bouton
          if (this.selectedVariants.size > 0) {
            this.updateButtonPrice();
          }
        } catch (e) {
          console.error('Erreur restauration localStorage:', e);
        }
      }

      interceptFetchRequests() {
        const originalFetch = window.fetch;
        const self = this;

        window.fetch = function(...args) {
          const [url, options] = args;

          if (url && (url.includes('/cart/add') || url.includes('cart_add_url'))) {
            // Détecter si cette requête vient du formulaire produit principal
            // ou d'un formulaire upsell/drawer indépendant
            let isFromMainForm = false;

            if (options && options.body instanceof FormData) {
              const formData = options.body;

              // Le formulaire principal contient le section-id qu'on connaît
              const formSectionId = formData.get('section-id');
              const mainFormSectionId = self.productForm ? self.productForm.querySelector('input[name="section-id"]')?.value : null;

              if (mainFormSectionId && formSectionId === mainFormSectionId) {
                isFromMainForm = true;
              }
            }

            // Intercepter uniquement les requêtes du formulaire principal quand on a des sélections bundle
            const shouldIntercept = isFromMainForm && self.selectedVariants.size > 0;

            if (shouldIntercept) {
              // Récupérer le selling_plan et properties depuis le FormData original
              let sellingPlanId = null;
              let formProperties = {};
              if (options && options.body instanceof FormData) {
                sellingPlanId = options.body.get('selling_plan');
                // Extraire toutes les properties[*] du FormData
                for (const [key, value] of options.body.entries()) {
                  const match = key.match(/^properties\[(.+)\]$/);
                  if (match && value) {
                    formProperties[match[1]] = value;
                  }
                }
              }

              // Construire le body JSON avec items[] (Shopify n'accepte items[] qu'en JSON)
              const items = [];
              self.selectedVariants.forEach((data, variantId) => {
                const item = {
                  id: parseInt(variantId),
                  quantity: data.quantity
                };
                // Attacher le selling_plan à chaque item si abonnement sélectionné
                if (sellingPlanId) {
                  item.selling_plan = parseInt(sellingPlanId);
                }
                // Attacher les properties (dont frequency) à chaque item
                if (Object.keys(formProperties).length > 0) {
                  item.properties = formProperties;
                }
                items.push(item);
              });

              // Ajouter les bocaux upsell-gift sélectionnés
              if (window.__upsellGift && typeof window.__upsellGift.getSelectedItems === 'function') {
                const giftItems = window.__upsellGift.getSelectedItems();
                giftItems.forEach((giftItem) => {
                  items.push({ id: giftItem.id, quantity: giftItem.quantity });
                });
              }

              const jsonBody = { items: items };

              // Récupérer sections/sections_url si présents dans le FormData original
              if (options && options.body instanceof FormData) {
                const formData = options.body;
                const sections = formData.get('sections');
                const sections_url = formData.get('sections_url');
                if (sections) jsonBody.sections = sections;
                if (sections_url) jsonBody.sections_url = sections_url;
              }

              // Remplacer le body par du JSON
              options.body = JSON.stringify(jsonBody);

              // Mettre à jour les headers pour JSON
              if (!options.headers) options.headers = {};
              if (options.headers instanceof Headers) {
                options.headers.set('Content-Type', 'application/json');
                options.headers.set('Accept', 'application/json');
              } else {
                options.headers['Content-Type'] = 'application/json';
                options.headers['Accept'] = 'application/json';
              }
            }

            const fetchPromise = originalFetch.apply(this, args);

            // Reset après succès (seulement pour bundle-pack)
            if (isFromMainForm && self.selectedVariants.size > 0) {
              return fetchPromise.then(response => {
                if (response.ok) {
                  setTimeout(() => {
                    self.clearLocalStorage();
                    self.reset();
                  }, 800);
                }
                return response;
              }).catch(error => {
                console.error('[BundlePack] Erreur:', error);
                throw error;
              });
            }

            return fetchPromise;
          }

          return originalFetch.apply(this, args);
        };
      }

      interceptFormSubmit() {
        if (!this.productForm) return;

        let productFormElement = document.querySelector('product-form');

        if (!productFormElement) {
          const submitButton = document.querySelector(`button[form="${this.productForm.id}"]`);
          if (submitButton) {
            productFormElement = submitButton.closest('product-form');
          }
        }

        if (!productFormElement) {
          return;
        }

        const tryInterceptSubmit = () => {
          if (!productFormElement.onSubmitHandler) {
            setTimeout(tryInterceptSubmit, 100);
            return;
          }

          const originalOnSubmitHandler = productFormElement.onSubmitHandler.bind(productFormElement);

          productFormElement.onSubmitHandler = (evt) => {
            if (this.displayMode === 'products' && this.selectedVariants.size > 0) {
              evt.preventDefault();
              this.addToCartViaAPI();
              return;
            }

            originalOnSubmitHandler(evt);
          };
        };

        tryInterceptSubmit();
      }

      async addToCartViaAPI() {
        // Récupérer le selling_plan depuis le formulaire (Seal Subscriptions)
        const sellingPlanInput = this.productForm ? this.productForm.querySelector('input[name="selling_plan"]') : null;
        const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

        const items = [];
        this.selectedVariants.forEach((data, variantId) => {
          const item = {
            id: variantId,
            quantity: data.quantity
          };
          if (sellingPlanId) {
            item.selling_plan = parseInt(sellingPlanId);
          }
          items.push(item);
        });

        // Ajouter les bocaux upsell-gift sélectionnés
        if (window.__upsellGift && typeof window.__upsellGift.getSelectedItems === 'function') {
          const giftItems = window.__upsellGift.getSelectedItems();
          giftItems.forEach((giftItem) => {
            items.push({ id: giftItem.id, quantity: giftItem.quantity });
          });
        }

        const submitButton = this.productForm.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.querySelector('span').textContent = 'Ajout en cours...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();

          submitButton.querySelector('span').textContent = '✓ Ajouté !';

          this.updateCartUI(result);

          setTimeout(() => {
            this.clearLocalStorage();
            this.reset();
          }, 1000);

          setTimeout(() => {
            // reset() a déjà appelé updateSubmitButtonState() — ne pas écraser l'état
            this.updateSubmitButtonState();
          }, 2000);

        } catch (error) {
          console.error('Erreur ajout au panier:', error);
          alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
          this.updateSubmitButtonState();
        }
      }

      updateCartUI(cartData) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCount = document.querySelector('cart-notification-button .cart-count-bubble span, #cart-icon-bubble span');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              const cartNotification = document.querySelector('cart-notification');
              if (cartNotification && typeof cartNotification.open === 'function') {
                cartNotification.open();
              }
            }
          })
          .catch(error => {
            // Silently fail
          });
      }

      loadConfiguration() {
        const config = this.container.dataset;
        if (config.tiers) {
          try {
            this.tiers = JSON.parse(config.tiers);
          } catch (e) {
            // Use defaults
          }
        }

        if (config.discounts) {
          try {
            this.discounts = JSON.parse(config.discounts);
          } catch (e) {
            // Use defaults
          }
        }

        // Configuration de la remise globale
        this.globalDiscountEnabled = config.globalDiscountEnabled === 'true';
        this.globalDiscountPercentage = parseFloat(config.globalDiscountPercentage) || 0;
        this.globalDiscountColor = config.globalDiscountColor || '#dc2626';

        // Minimum de saveurs requises pour débloquer l'ATC
        this.minTotalQuantity = parseInt(config.minTotalQuantity) || 0;
        this.minTotalLockedText = config.minTotalLockedText || 'Choisissez encore {remaining} saveur(s)';

        // Appliquer la remise globale si activée
        if (this.globalDiscountEnabled && this.globalDiscountPercentage > 0) {
          this.applyGlobalDiscountToPrices();

          if (this.quantityMeter) {
            this.quantityMeter.classList.add('quantity-meter-addon--global-discount');
          }
        } else {
          if (this.quantityMeter) {
            this.quantityMeter.classList.remove('quantity-meter-addon--global-discount');
          }
        }

      }

      applyGlobalDiscountToPrices() {
        const priceElements = this.container.querySelectorAll('.quantity-meter-addon-item__price[data-original-price]');

        priceElements.forEach(priceEl => {
          const originalPriceText = priceEl.dataset.originalPrice;

          const priceRegex = /(\d+(?:[.,]\d+)?)\s*([€$£])/;
          const match = originalPriceText.match(priceRegex);

          if (match) {
            const originalPrice = parseFloat(match[1].replace(',', '.'));
            const currency = match[2];
            const suffix = originalPriceText.substring(match.index + match[0].length);

            const discountedPrice = originalPrice * (1 - this.globalDiscountPercentage / 100);

            let formattedDiscountedPrice;
            if (originalPriceText.includes(',') || originalPriceText.includes('.')) {
              formattedDiscountedPrice = discountedPrice.toFixed(2).replace('.', ',');
            } else {
              formattedDiscountedPrice = Math.round(discountedPrice).toString();
            }

            priceEl.innerHTML = `
              <span class="quantity-meter-addon-item__price--original">${originalPriceText}</span>
              <span class="quantity-meter-addon-item__price--discounted" style="color: ${this.globalDiscountColor};">
                ${formattedDiscountedPrice}${currency}${suffix}
              </span>
            `;
          }
        });
      }

      bindEvents() {
        // Quantity input events
        this.quantityInputs.forEach(input => {
          const quantityContainer = input.closest('.bundle-pack-card__quantity-controls');
          const plusButton = quantityContainer.querySelector('[name="plus"]');
          const minusButton = quantityContainer.querySelector('[name="minus"]');

          plusButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.incrementQuantity(input);
          });

          minusButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.decrementQuantity(input);
          });
        });

        // Add button events
        const addButtons = this.container.querySelectorAll('.bundle-pack-card__add-button');
        addButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleAddButtonClick(button);
          });
        });

        // Card click events
        this.cards.forEach(card => {
          card.addEventListener('click', (e) => {
            if (e.target.closest('.bundle-pack-card__quantity-controls')) return;
            if (e.target.closest('.bundle-pack-card__add-button')) return;
            if (e.target.closest('a')) return;
            this.handleCardClick(card);
          });
        });
      }

      handleQuantityChangeDirectly(input, quantity) {
        const variantId = input.dataset.variantId;
        const card = input.closest('.bundle-pack-card');

        const max = parseInt(input.dataset.max) || 999;

        if (quantity < 0) {
          input.value = 0;
          quantity = 0;
        }

        if (quantity > max) {
          input.value = max;
          quantity = max;
        }

        if (quantity > 0) {
          const compareAtPrice = card.dataset.variantCompareAtPrice;
          this.selectedVariants.set(variantId, {
            quantity: quantity,
            price: parseInt(card.dataset.variantPrice),
            compare_at_price: compareAtPrice ? parseInt(compareAtPrice) : null,
            title: card.querySelector('.bundle-pack-card__title').textContent.trim()
          });
          card.classList.add('bundle-pack-card--selected');
        } else {
          this.selectedVariants.delete(variantId);
          card.classList.remove('bundle-pack-card--selected');
        }
        this.toggleQuantityDisplay(card, quantity);
        this.updateQuantityButtons(input);
        this.updateQuantityMeter();
        this.updateGridCardStates();
        this.updateProductForm();
        this.updateSummary();
        this.saveToLocalStorage();
      }

      incrementQuantity(input) {
        const currentValue = parseInt(input.value) || 0;
        const max = parseInt(input.dataset.max) || 999;

        if (currentValue < max) {
          const newValue = currentValue + 1;
          input.value = newValue;
          this.handleQuantityChangeDirectly(input, newValue);
        }
      }

      decrementQuantity(input) {
        const currentValue = parseInt(input.value) || 0;

        if (currentValue > 0) {
          const newValue = currentValue - 1;
          input.value = newValue;
          this.handleQuantityChangeDirectly(input, newValue);
        }
      }

      updateQuantityButtons(input) {
        const quantityContainer = input.closest('.bundle-pack-card__quantity-controls');
        const plusButton = quantityContainer.querySelector('[name="plus"]');
        const minusButton = quantityContainer.querySelector('[name="minus"]');

        const value = parseInt(input.value) || 0;
        const max = parseInt(input.dataset.max) || 999;

        const shouldDisableMinus = value <= 0;
        const shouldDisablePlus = value >= max;

        minusButton.disabled = shouldDisableMinus;
        plusButton.disabled = shouldDisablePlus;

        minusButton.classList.toggle('disabled', shouldDisableMinus);
        plusButton.classList.toggle('disabled', shouldDisablePlus);
      }

      handleCardClick(card) {
        const input = card.querySelector('.bundle-pack-card__quantity-input');
        if (!input || card.classList.contains('bundle-pack-card--unavailable')) return;

        const currentQuantity = parseInt(input.value) || 0;
        if (currentQuantity === 0) {
          this.incrementQuantity(input);
        }
      }

      initializeQuantityButtons() {
        this.quantityInputs.forEach(input => {
          this.updateQuantityButtons(input);
        });
      }

      initializeAddButtons() {
        this.cards.forEach(card => {
          const input = card.querySelector('.bundle-pack-card__quantity-input');
          if (input) {
            const quantity = parseInt(input.value) || 0;
            this.toggleQuantityDisplay(card, quantity);
          }
        });
      }

      /**
       * Pré-sélectionne le produit principal (la page courante) avec quantité 1.
       * Le produit principal est identifié par data-is-main-product="true" dans le HTML.
       * Son input a déjà value="1" côté Liquid — ici on synchronise la Map selectedVariants.
       */
      initializeMainProduct() {
        const mainCard = this.container.querySelector('.bundle-pack-card[data-is-main-product="true"]');
        if (!mainCard) return;

        const variantId = mainCard.dataset.variantId;
        const price = parseInt(mainCard.dataset.variantPrice) || 0;
        const compareAtPrice = mainCard.dataset.variantCompareAtPrice;
        const titleEl = mainCard.querySelector('.bundle-pack-card__title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        const available = mainCard.dataset.variantAvailable === 'true';

        if (!available) return;

        // Enregistrer dans la Map avec quantité 1
        this.selectedVariants.set(variantId, {
          quantity: 1,
          price: price,
          compare_at_price: compareAtPrice ? parseInt(compareAtPrice) : null,
          title: title
        });

        // S'assurer que l'UI est synchronisée
        mainCard.classList.add('bundle-pack-card--selected');
        const input = mainCard.querySelector('.bundle-pack-card__quantity-input');
        if (input) {
          input.value = 1;
          this.updateQuantityButtons(input);
        }
        this.toggleQuantityDisplay(mainCard, 1);
      }

      toggleQuantityDisplay(card, quantity) {
        const addButton = card.querySelector('.bundle-pack-card__add-button');
        const quantityControls = card.querySelector('.bundle-pack-card__quantity-controls');

        if (!addButton || !quantityControls) return;

        if (quantity === 0) {
          addButton.style.display = 'inline-flex';
          quantityControls.style.display = 'none';
        } else {
          addButton.style.display = 'none';
          quantityControls.style.display = 'flex';
        }
      }

      handleAddButtonClick(button) {
        const variantId = button.dataset.variantId;
        const card = button.closest('.bundle-pack-card');
        const input = card.querySelector(`.bundle-pack-card__quantity-input[data-variant-id="${variantId}"]`);

        if (input && !card.classList.contains('bundle-pack-card--unavailable')) {
          input.value = 1;
          this.handleQuantityChangeDirectly(input, 1);
        }
      }

      /* ── Grid Layout Mode ── */

      initGridLayout() {
        this.isGridLayout = this.container.dataset.gridLayout === 'true';
        if (!this.isGridLayout) return;

        const grid = this.container.querySelector('.bundle-pack-grid');
        if (grid) grid.classList.add('grid-mode');

        // Disable scroll wrapper in grid mode
        const scrollWrapper = this.container.querySelector('.bundle-pack-scroll-wrapper');
        if (scrollWrapper) {
          scrollWrapper.style.maxHeight = 'none';
          scrollWrapper.style.overflow = 'visible';
          const indicator = scrollWrapper.querySelector('.bundle-pack-scroll-indicator');
          if (indicator) indicator.style.display = 'none';
        }

        this.updateGridCardStates();
      }

      updateGridCardStates() {
        // No-op: grid mode has no special card states
      }

      updateQuantityMeter() {
        if (!this.quantityMeter) return;

        let totalQuantity = 0;
        this.selectedVariants.forEach(data => {
          totalQuantity += data.quantity;
        });

        // Mettre à jour la barre de progression
        const progressLine = this.quantityMeter.querySelector('[data-progress-line-addon]');
        const items = this.quantityMeter.querySelectorAll('.quantity-meter-addon-item');

        // Mettre à jour le badge par palier (texte personnalisé par palier)
        const shippingBadge = this.quantityMeter.querySelector('[data-shipping-badge]');
        if (shippingBadge) {
          let activeBadgeText = '';
          for (let i = this.tiers.length - 1; i >= 0; i--) {
            if (totalQuantity >= this.tiers[i].qty && items[i]) {
              activeBadgeText = items[i].dataset.tierBadge || '';
              break;
            }
          }

          const badgeTextEl = shippingBadge.querySelector('[data-badge-text]');
          if (activeBadgeText) {
            if (badgeTextEl) badgeTextEl.textContent = activeBadgeText;
            shippingBadge.classList.add('visible', 'active');
          } else {
            shippingBadge.classList.remove('visible', 'active');
          }
        }

        let progress = 0;
        let currentTier = 0;
        let lastActiveTier = -1;

        for (let i = 0; i < this.tiers.length; i++) {
          const tier = this.tiers[i];
          const circle = items[i] ? items[i].querySelector('.quantity-meter-addon-item__circle') : null;
          const circleInner = items[i] ? items[i].querySelector('.quantity-meter-addon-item__circle-inner') : null;
          const estAtteint = totalQuantity >= tier.qty;

          if (estAtteint) {
            if (circle) circle.classList.add('filled');
            if (circleInner) circleInner.classList.add('filled');
            lastActiveTier = i;
            currentTier = i;
            progress = ((i + 1) / this.tiers.length) * 100;
          } else {
            if (circle) circle.classList.remove('filled');
            if (circleInner) circleInner.classList.remove('filled');
          }
        }

        for (let i = 0; i < this.tiers.length; i++) {
          const priceElement = items[i] ? items[i].querySelector('.quantity-meter-addon-item__price') : null;
          const estPrixActif = (i === lastActiveTier);

          if (estPrixActif) {
            if (priceElement) priceElement.classList.remove('subdued');
          } else {
            if (priceElement) priceElement.classList.add('subdued');
          }
        }

        if (items.length > 0) {
          const firstCircle = items[0].querySelector('.quantity-meter-addon-item__circle');
          const lastCircle = items[items.length - 1].querySelector('.quantity-meter-addon-item__circle');
          const activeCircle = items[currentTier].querySelector('.quantity-meter-addon-item__circle');

          if (firstCircle && lastCircle && activeCircle) {
            const CORRECTION = 10;

            const firstCenter = firstCircle.offsetLeft + firstCircle.offsetWidth / 2 + CORRECTION;
            const lastCenter = lastCircle.offsetLeft + lastCircle.offsetWidth / 2 + CORRECTION;
            const activeCenter = activeCircle.offsetLeft + activeCircle.offsetWidth / 2 + CORRECTION;

            const bgLine = this.quantityMeter.querySelector('.quantity-meter-addon-line');
            if (bgLine) {
              bgLine.style.left = firstCenter + 'px';
              bgLine.style.width = (lastCenter - firstCenter) + 'px';
            }

            if (progressLine) {
              if (currentTier > 0) {
                progressLine.style.left = firstCenter + 'px';
                progressLine.style.width = (activeCenter - firstCenter) + 'px';
              } else {
                progressLine.style.left = firstCenter + 'px';
                progressLine.style.width = '0';
              }
            }
          }
        }

        this.updateGifts(totalQuantity);
      }

      updateGifts(totalQuantity) {
        const event = new CustomEvent('bundlePackQuantityChanged', {
          detail: {
            totalQuantity: totalQuantity,
            selectedVariants: Array.from(this.selectedVariants.entries())
          }
        });
        document.dispatchEvent(event);
      }

      updateProductForm() {
        // Le formulaire Dawn reste intact — l'intercepteur fetch remplace le body en JSON
        this.updateButtonPrice();
        this.updateSubmitButtonState();
      }

      updateSubmitButtonState() {
        const submitButton = document.querySelector('.product-form__submit');
        if (!submitButton) return;

        const textEl = submitButton.querySelector('.product-form__submit-text');
        const separatorEl = submitButton.querySelector('.product-form__submit-separator');
        const priceEl = submitButton.querySelector('.product-form__submit-price');
        if (!textEl) return;

        const hasSelections = this.selectedVariants.size > 0;
        let totalQuantity = 0;
        this.selectedVariants.forEach((data) => {
          totalQuantity += data.quantity;
        });
        const belowMinimum = this.minTotalQuantity > 0 && totalQuantity < this.minTotalQuantity;

        if (!hasSelections) {
          submitButton.disabled = true;
          submitButton.style.opacity = '0.5';
          submitButton.style.cursor = 'not-allowed';
          textEl.textContent = this.minTotalQuantity > 0
            ? this.formatLockedText(0)
            : 'Sélectionnez un produit';
          if (separatorEl) separatorEl.style.display = 'none';
          if (priceEl) priceEl.style.display = 'none';
        } else if (belowMinimum) {
          submitButton.disabled = true;
          submitButton.style.opacity = '0.5';
          submitButton.style.cursor = 'not-allowed';
          textEl.textContent = this.formatLockedText(totalQuantity);
          if (separatorEl) separatorEl.style.display = 'none';
          if (priceEl) priceEl.style.display = 'none';
        } else {
          submitButton.disabled = false;
          submitButton.style.opacity = '';
          submitButton.style.cursor = '';
          textEl.textContent = 'Ajouter au panier';
          if (separatorEl) separatorEl.style.display = '';
          if (priceEl) priceEl.style.display = '';
        }
      }

      formatLockedText(totalQuantity) {
        const remaining = Math.max(0, this.minTotalQuantity - totalQuantity);
        return this.minTotalLockedText
          .replace(/\{remaining\}/g, String(remaining))
          .replace(/\{min\}/g, String(this.minTotalQuantity));
      }

      updateButtonPrice() {
        if (!this.selectedVariants) {
          return;
        }

        let totalQuantity = 0;
        this.selectedVariants.forEach((data) => {
          totalQuantity += data.quantity;
        });

        let activeTier = null;

        // Parcourir les paliers en ordre décroissant pour trouver le palier actif
        for (let i = this.tiers.length - 1; i >= 0; i--) {
          if (totalQuantity >= this.tiers[i].qty) {
            activeTier = String(i + 1);
            break;
          }
        }

        let totalPriceBeforeDiscount = 0;
        this.selectedVariants.forEach((data) => {
          totalPriceBeforeDiscount += (data.price * data.quantity);
        });

        let totalCompareAtPrice = 0;
        this.selectedVariants.forEach((data) => {
          const comparePrice = data.compare_at_price || data.price;
          totalCompareAtPrice += (comparePrice * data.quantity);
        });

        let totalPrice = totalPriceBeforeDiscount;
        const discount = this.discounts[activeTier];

        if (discount && discount.type !== 'none') {
          if (discount.type === 'percentage') {
            // Arrondir au centime supérieur par unité pour correspondre au prix facturé par l'app
            const reductionMultiplier = (1 - discount.value / 100);
            let discountedTotal = 0;
            this.selectedVariants.forEach((data) => {
              const unitDiscounted = Math.ceil(data.price * reductionMultiplier);
              discountedTotal += unitDiscounted * data.quantity;
            });
            totalPrice = discountedTotal;
          } else if (discount.type === 'fixed') {
            const discountInCentimes = discount.value * 100;
            totalPrice = totalPriceBeforeDiscount - discountInCentimes;
          }
        }

        totalPrice = Math.round(totalPrice);

        const event = new CustomEvent('bundlePackPrice:change', {
          detail: {
            totalPrice: totalPrice,
            totalPriceBeforeDiscount: totalPriceBeforeDiscount,
            totalCompareAtPrice: totalCompareAtPrice,
            selectedVariants: Array.from(this.selectedVariants.entries()),
            hasSelections: this.selectedVariants.size > 0,
            activeTier: activeTier,
            totalQuantity: totalQuantity,
            discount: discount,
            globalDiscountApplied: false
          }
        });
        document.dispatchEvent(event);
      }

      updateSummary() {
        const summaryContainer = this.container.querySelector('.bundle-pack__summary');
        if (!summaryContainer) return;

        const summaryContent = summaryContainer.querySelector('.bundle-pack__summary-content');
        if (!summaryContent) return;

        summaryContent.innerHTML = '';

        if (this.selectedVariants.size === 0) {
          summaryContainer.classList.remove('has-selections');
          return;
        }

        summaryContainer.classList.add('has-selections');

        let totalQuantity = 0;
        this.selectedVariants.forEach((data) => {
          totalQuantity += data.quantity;
        });

        let activeTier = null;

        for (let i = this.tiers.length - 1; i >= 0; i--) {
          if (totalQuantity >= this.tiers[i].qty) {
            activeTier = String(i + 1);
            break;
          }
        }

        let totalPriceBeforeDiscount = 0;

        this.selectedVariants.forEach((data, variantId) => {
          const itemTotal = (data.price * data.quantity) / 100;
          totalPriceBeforeDiscount += itemTotal;

          const summaryItem = document.createElement('div');
          summaryItem.className = 'bundle-pack__summary-item';
          summaryItem.innerHTML = `
            <span>${data.title} × ${data.quantity}</span>
            <span>€${itemTotal.toFixed(2)}</span>
          `;
          summaryContent.appendChild(summaryItem);
        });

        let totalPrice = totalPriceBeforeDiscount;
        const discount = this.discounts[activeTier];

        if (discount && discount.type !== 'none') {
          if (discount.type === 'percentage') {
            // Arrondir au centime supérieur par unité pour correspondre au prix facturé par l'app
            const reductionMultiplier = (1 - discount.value / 100);
            let discountedTotal = 0;
            this.selectedVariants.forEach((data) => {
              const unitDiscounted = Math.ceil(data.price * reductionMultiplier) / 100;
              discountedTotal += unitDiscounted * data.quantity;
            });
            totalPrice = discountedTotal;
          } else if (discount.type === 'fixed') {
            totalPrice = totalPriceBeforeDiscount - discount.value;
          }

          const discountItem = document.createElement('div');
          discountItem.className = 'bundle-pack__summary-item bundle-pack__summary-discount';
          const discountAmount = totalPriceBeforeDiscount - totalPrice;
          discountItem.innerHTML = `
            <span>Discount (${discount.type === 'percentage' ? discount.value + '%' : '€' + discount.value})</span>
            <span>-€${discountAmount.toFixed(2)}</span>
          `;
          summaryContent.appendChild(discountItem);
        }

        const totalItem = document.createElement('div');
        totalItem.className = 'bundle-pack__summary-total';
        totalItem.innerHTML = `
          <span>Total (${totalQuantity} items)</span>
          <span>€${totalPrice.toFixed(2)}</span>
        `;
        summaryContent.appendChild(totalItem);
      }

      // Public methods for external integration
      getSelectedVariants() {
        return Array.from(this.selectedVariants.entries());
      }

      getTotalQuantity() {
        let total = 0;
        this.selectedVariants.forEach(data => {
          total += data.quantity;
        });
        return total;
      }

      getTotalPrice() {
        let total = 0;
        this.selectedVariants.forEach(data => {
          total += (data.price * data.quantity);
        });
        return total;
      }

      reset() {
        this.selectedVariants.clear();

        this.quantityInputs.forEach(input => {
          input.value = 0;
          this.updateQuantityButtons(input);
        });
        this.cards.forEach(card => {
          card.classList.remove('bundle-pack-card--selected');
          this.toggleQuantityDisplay(card, 0);
        });

        // Re-pré-sélectionner le produit principal à 1
        this.initializeMainProduct();

        this.updateQuantityMeter();
        this.updateProductForm();
        this.updateSummary();
      }

      initializeScrollIndicator() {
        const scrollWrapper = this.container.querySelector('.bundle-pack-scroll-wrapper');
        if (!scrollWrapper) return;

        const checkScrollNeeded = () => {
          // Mesurer la grille seule, avec une tolérance pour éviter les faux positifs
          const grid = scrollWrapper.querySelector('.bundle-pack-grid');
          const contentHeight = grid ? grid.scrollHeight : scrollWrapper.scrollHeight;
          const hasScroll = contentHeight > scrollWrapper.clientHeight + 10;
          if (!hasScroll) {
            scrollWrapper.classList.add('no-scroll');
          } else {
            scrollWrapper.classList.remove('no-scroll');
          }
        };

        const handleScroll = () => {
          const scrollTop = scrollWrapper.scrollTop;
          const scrollHeight = scrollWrapper.scrollHeight;
          const clientHeight = scrollWrapper.clientHeight;

          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;

          if (isAtBottom) {
            scrollWrapper.classList.add('scrolled-to-bottom');
          } else {
            scrollWrapper.classList.remove('scrolled-to-bottom');
          }
        };

        checkScrollNeeded();
        handleScroll();

        scrollWrapper.addEventListener('scroll', handleScroll);

        setTimeout(() => {
          checkScrollNeeded();
          handleScroll();
        }, 500);

        window.addEventListener('resize', () => {
          checkScrollNeeded();
          handleScroll();
        });
      }
    }

    // Auto-initialize when DOM is ready
    function initializeBundlePack() {
      const containers = document.querySelectorAll('[data-bundle-pack]');
      containers.forEach(container => {
        if (!container.bundlePackAddon) {
          container.bundlePackAddon = new BundlePackAddon(container);
        }
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBundlePack);
    } else {
      initializeBundlePack();
    }

    // Re-initialize on theme section loads (for theme editor)
    document.addEventListener('shopify:section:load', initializeBundlePack);

    // Export for global access
    window.BundlePackAddon = BundlePackAddon;

  })();
